/* Registrazione del service worker e gestione degli aggiornamenti.
 *
 * Flusso:
 *  - registra /service-worker.js;
 *  - quando un NUOVO worker è pronto (state 'installed' con un controller già
 *    attivo = è un aggiornamento, non la prima installazione), avvisa la pagina
 *    con l'evento window 'sw-update-available' → mostra il banner "Aggiorna";
 *  - al click, applyUpdate() dice al worker in attesa di attivarsi (SKIP_WAITING);
 *  - all'attivazione ('controllerchange') la pagina si ricarica UNA sola volta;
 *  - controlla periodicamente e al ritorno in primo piano se c'è una versione nuova.
 */

const INTERVALLO_CONTROLLO_MS = 15 * 60 * 1000; // ogni 15 minuti

let workerInAttesa = null; // il worker installato in attesa di attivarsi
let inRicarica = false; // guardia anti-loop di reload

/** Applica l'aggiornamento: chiamata dal pulsante "Aggiorna" del banner. */
export function applyUpdate() {
  if (workerInAttesa) {
    workerInAttesa.postMessage({ type: "SKIP_WAITING" });
  }
}

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  // In sviluppo non c'è build né SW servito: evitiamo di cachare durante il dev
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        // Controllo periodico degli aggiornamenti
        setInterval(() => registration.update().catch(() => {}), INTERVALLO_CONTROLLO_MS);

        // ...e ogni volta che la pagina torna visibile (l'utente riapre la PWA)
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            registration.update().catch(() => {});
          }
        });

        // Un nuovo worker sta arrivando
        registration.addEventListener("updatefound", () => {
          const nuovo = registration.installing;
          if (!nuovo) return;
          nuovo.addEventListener("statechange", () => {
            // 'installed' + esiste già un controller ⇒ è un AGGIORNAMENTO
            if (nuovo.state === "installed" && navigator.serviceWorker.controller) {
              workerInAttesa = registration.waiting || nuovo;
              window.dispatchEvent(new CustomEvent("sw-update-available"));
            }
          });
        });
      })
      .catch(() => {});

    // Quando il nuovo worker prende il controllo, ricarichiamo (una volta sola)
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (inRicarica) return;
      inRicarica = true;
      window.location.reload();
    });
  });
}
